// From https://github.com/kbaum/browser-timezone-rails
window.BrowserTZone || (window.BrowserTZone = {});

window.BrowserTZone.setCookie = function() {
  return $.cookie("browser.timezone", window.jstz.determine().name(), {
    expires: 365,
    path: "/"
  });
};

jQuery(function() {
  return window.BrowserTZone.setCookie();
});
